/* eslint-disable import/prefer-default-export */
export enum ContentfulContentType {
  ContentfulBlade = 'ContentfulBlade',
  ContentfulLinkWrapper = 'ContentfulLinkWrapper'
}
